import { useMemo } from 'react';
import { ShiftPickerModal } from './ShiftPickerModal';
import { shiftJoinOptions, type EventShift } from '@/utils/eventShifts';

interface PickShiftsModalProps {
  isOpen: boolean;
  /** Every shift on the event. */
  shifts: EventShift[];
  submitting?: boolean;
  onClose: () => void;
  onConfirm: (shiftIds: string[]) => void;
}

/** Add yourself to more of the event's shifts, after being accepted onto it. */
export function PickShiftsModal({ isOpen, shifts, submitting, onClose, onConfirm }: PickShiftsModalProps) {
  const { options, notes } = useMemo(() => shiftJoinOptions(shifts), [shifts]);

  return (
    <ShiftPickerModal
      isOpen={isOpen}
      title="Pick shifts"
      intro="Choose any upcoming shifts you can also work. The organizer is told which ones you picked."
      options={options}
      notes={notes}
      multiple
      emptyText="You are already on every upcoming shift of this event."
      confirmLabel={(count) => (count > 1 ? `Add ${count} shifts` : 'Add shift')}
      submitting={submitting}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
